
  const inventoryIssueResolution = {
    path: "/inventoryReservation/issues",
    name: "inventoryIssueResolution",
    component: () => import(/* webpackChunkName: "inventory_reservation_issues" */ "@/components/inventoryReservation/InventoryIssueResolution.vue"),
    meta: { authorize: ['Administrator', 'Manager', 'Factory'], requiresAuth: true }
  };

export default inventoryIssueResolution;
